import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "data-testid": "edit-b2c-user-page",
  class: "page edit-b2c-user-page"
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_AppUploader = _resolveComponent("AppUploader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.pensionStatus && Object.keys(_ctx.pensionStatus).length > 0)
                ? (_openBlock(), _createBlock(_component_v_tabs, {
                    key: 0,
                    modelValue: _ctx.tabs,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabs) = $event)),
                    color: "primary",
                    "center-active": "",
                    centered: "",
                    grow: "",
                    "bg-color": "#fff",
                    "show-arrows": "",
                    class: "mt-5 mb-12"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pensionStatus, (card, id) => {
                        return (_openBlock(), _createBlock(_component_v_tab, {
                          key: id,
                          onClick: ($event: any) => (_ctx.changeCurrentProvider(id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_tooltip, { location: "bottom" }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("pre", _mergeProps({ ref_for: true }, props), _toDisplayString(`${card.name.length > 30 ? `${card.name.substring(0, 30)}..` : card.name}${
                      card.deletedByUser ? '(deleted)' : ''
                    }`), 17)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(`${card.name}${card.providerName ? `(${card.providerName})` : ''}`), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_window, {
                modelValue: _ctx.tabs,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tabs) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pensionStatus, (card, id) => {
                    return (_openBlock(), _createBlock(_component_v_window_item, { key: id }, {
                      default: _withCtx(() => [
                        (_ctx.currentB2CUser.id !== '')
                          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_form, {
                                  onSubmit: _withModifiers(_ctx.editUser, ["prevent"]),
                                  class: "py-5"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between my-4" }, {
                                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("span", { class: "text-h5" }, " Edit User ", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    (_ctx.pensionStatus)
                                      ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("div", null, [
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_v_label, null, {
                                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                    _createTextVNode("User Email", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_text_field, {
                                                  "hide-details": "",
                                                  "persistent-hint": false,
                                                  placeholder: "Email",
                                                  modelValue: _ctx.currentB2CUser.email,
                                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentB2CUser.email) = $event)),
                                                  disabled: true,
                                                  class: "mb-5"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_v_btn, {
                                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showingDownloadModal = true))
                                                }, {
                                                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                    _createTextVNode(" View Documents ", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ])
                                            ], 512), [
                                              [_vShow, true]
                                            ]),
                                            _createVNode(_component_v_container, { "grid-list-md": "" }, {
                                              default: _withCtx(() => [
                                                (!_ctx.dataUploaded)
                                                  ? (_openBlock(), _createBlock(_component_v_layout, {
                                                      key: 0,
                                                      "data-testid": "Upload-Container",
                                                      wrap: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: 12,
                                                              class: "text-center mt-2"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_AppUploader, {
                                                                  "data-testid": "FileUpload",
                                                                  onAppUploader: _ctx.handleFile,
                                                                  disabled: _ctx.updatingUser,
                                                                  fileType: "*"
                                                                }, null, 8, ["onAppUploader", "disabled"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (_ctx.dataUploaded)
                                                  ? (_openBlock(), _createBlock(_component_v_layout, {
                                                      key: 1,
                                                      wrap: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_alert, {
                                                                  modelValue: _ctx.dataUploaded,
                                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataUploaded) = $event)),
                                                                  closable: "",
                                                                  type: "success",
                                                                  class: "mb-4",
                                                                  prominent: ""
                                                                }, {
                                                                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                                    _createTextVNode("Provider updated successfully.", -1)
                                                                  ]))]),
                                                                  _: 1
                                                                }, 8, ["modelValue"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (_ctx.dataUploadError)
                                                  ? (_openBlock(), _createBlock(_component_v_layout, {
                                                      key: 2,
                                                      wrap: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_alert, {
                                                                  "data-testid": "FileUploadError",
                                                                  modelValue: _ctx.dataUploadError,
                                                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataUploadError) = $event)),
                                                                  closable: "",
                                                                  type: "error",
                                                                  class: "mb-4",
                                                                  prominent: ""
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.validationError), 1)
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["modelValue"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterPensionStatus(_ctx.pensionStatus), (card, id) => {
                                              return (_openBlock(), _createBlock(_component_v_col, {
                                                card: card,
                                                id: id,
                                                key: id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { dense: "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { cols: "12" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_card, { elevation: 6 }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_row, null, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_col, { cols: "12" }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_img, {
                                                                        src: 
                                    card.img
                                      ? card.img
                                      : 'https://storage.googleapis.com/download/storage/v1/b/aw-onboard-test.appspot.com/o/images%2Fdefault-pension.jpg?generation=1594894259066708&alt=media'
                                  ,
                                                                        "max-height": "100px",
                                                                        "min-height": "100px",
                                                                        "max-width": "100%"
                                                                      }, null, 8, ["src"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_card_title, { style: {"display":"grid"} }),
                                                              _createVNode(_component_v_card_text, { style: {"font-size":"30px","color":"black"} }, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, { class: "text-left" }, {
                                                                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                                        _createTextVNode("Pension ID", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      value: _ctx.currentProviderUUIDForUser,
                                                                      readonly: true,
                                                                      class: "mb-5"
                                                                    }, null, 8, ["value"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                        _createTextVNode("Pension Type", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      value: card.type === 'pen' ? 'Pension Provider' : 'Employer Details',
                                                                      disabled: true,
                                                                      class: "mb-5"
                                                                    }, null, 8, ["value"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                                        _createTextVNode("Name", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      value: card.name,
                                                                      class: "mb-5"
                                                                    }, null, 8, ["value"])
                                                                  ]),
                                                                  (card.type === 'pen')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                                        _createVNode(_component_v_label, null, {
                                                                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                                            _createTextVNode("Provider pays into pension?", -1)
                                                                          ]))]),
                                                                          _: 1
                                                                        }),
                                                                        _createVNode(_component_v_text_field, {
                                                                          "hide-details": "",
                                                                          variant: "underlined",
                                                                          value: card.employerPaysIntoThisPension ? 'Yes' : 'No',
                                                                          "persistent-hint": false,
                                                                          disabled: true,
                                                                          class: "mb-5"
                                                                        }, null, 8, ["value"])
                                                                      ]))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                                        _createVNode(_component_v_label, null, {
                                                                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                                            _createTextVNode("Provider", -1)
                                                                          ]))]),
                                                                          _: 1
                                                                        }),
                                                                        _createVNode(_component_v_autocomplete, {
                                                                          "hide-details": "",
                                                                          items: 
                                    _ctx.providers.map((p) => {
                                      return { title: p.name, value: p.id };
                                    })
                                  ,
                                                                          "persistent-hint": false,
                                                                          modelValue: card.providerId,
                                                                          "onUpdate:modelValue": ($event: any) => ((card.providerId) = $event),
                                                                          onChange: ($event: any) => (_ctx.providerChange(card.providerId)),
                                                                          class: "mb-5",
                                                                          variant: "underlined"
                                                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "onChange"]),
                                                                        _createVNode(_component_v_label, null, {
                                                                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                                            _createTextVNode("Provider Policy ID", -1)
                                                                          ]))]),
                                                                          _: 1
                                                                        }),
                                                                        _createVNode(_component_v_text_field, {
                                                                          "hide-details": "",
                                                                          variant: "underlined",
                                                                          "persistent-hint": false,
                                                                          modelValue: card.providerPolicyID,
                                                                          "onUpdate:modelValue": ($event: any) => ((card.providerPolicyID) = $event),
                                                                          class: "mb-5"
                                                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                                        _createVNode(_component_v_label, null, {
                                                                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                                            _createTextVNode("Start Year", -1)
                                                                          ]))]),
                                                                          _: 1
                                                                        }),
                                                                        _createVNode(_component_v_text_field, {
                                                                          "hide-details": "",
                                                                          variant: "underlined",
                                                                          value: card.startYear,
                                                                          "persistent-hint": false,
                                                                          disabled: true,
                                                                          class: "mb-5"
                                                                        }, null, 8, ["value"]),
                                                                        _createVNode(_component_v_label, null, {
                                                                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                                                            _createTextVNode("End Year", -1)
                                                                          ]))]),
                                                                          _: 1
                                                                        }),
                                                                        _createVNode(_component_v_text_field, {
                                                                          "hide-details": "",
                                                                          variant: "underlined",
                                                                          value: card.endYear,
                                                                          "persistent-hint": false,
                                                                          disabled: true,
                                                                          class: "mb-5"
                                                                        }, null, 8, ["value"]),
                                                                        _createVNode(_component_v_label, null, {
                                                                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                                            _createTextVNode("Still Works Here?", -1)
                                                                          ]))]),
                                                                          _: 1
                                                                        }),
                                                                        _createVNode(_component_v_text_field, {
                                                                          "hide-details": "",
                                                                          variant: "underlined",
                                                                          value: card.stillWorksHere ? 'Yes' : 'No',
                                                                          "persistent-hint": false,
                                                                          disabled: true,
                                                                          class: "mb-5"
                                                                        }, null, 8, ["value"])
                                                                      ])),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                                        _createTextVNode("Policy Number", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      modelValue: card.pensionPolicy,
                                                                      "onUpdate:modelValue": ($event: any) => ((card.pensionPolicy) = $event),
                                                                      disabled: true,
                                                                      type: "text",
                                                                      class: "mb-5"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                                        _createTextVNode("Agewage Score", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      modelValue: card.score,
                                                                      "onUpdate:modelValue": ($event: any) => ((card.score) = $event),
                                                                      type: "number",
                                                                      class: "mb-5"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                                        _createTextVNode("Return %", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      modelValue: card.return,
                                                                      "onUpdate:modelValue": ($event: any) => ((card.return) = $event),
                                                                      type: "number",
                                                                      class: "mb-5"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                                        _createTextVNode("Average Return", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      modelValue: card.avgReturn,
                                                                      "onUpdate:modelValue": ($event: any) => ((card.avgReturn) = $event),
                                                                      type: "number",
                                                                      class: "mb-5"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                                                        _createTextVNode("Current NAV value", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      modelValue: card.currVal,
                                                                      "onUpdate:modelValue": ($event: any) => ((card.currVal) = $event),
                                                                      type: "number",
                                                                      class: "mb-5"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                                        _createTextVNode("Benchmark NAV value", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      modelValue: card.benchmarkNAV,
                                                                      "onUpdate:modelValue": ($event: any) => ((card.benchmarkNAV) = $event),
                                                                      type: "number",
                                                                      class: "mb-5"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                                        _createTextVNode("Total Contribution", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      modelValue: card.totalContribution,
                                                                      "onUpdate:modelValue": ($event: any) => ((card.totalContribution) = $event),
                                                                      type: "number",
                                                                      class: "mb-5"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_label, null, {
                                                                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                                        _createTextVNode("Contribution Period(YYYY-YYYY)", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_text_field, {
                                                                      "hide-details": "",
                                                                      variant: "underlined",
                                                                      "persistent-hint": false,
                                                                      modelValue: card.contributionPeriod,
                                                                      "onUpdate:modelValue": ($event: any) => ((card.contributionPeriod) = $event),
                                                                      class: "mb-5"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _createElementVNode("div", null, [
                                                                    _createVNode(_component_v_switch, {
                                                                      color: "accent",
                                                                      "hide-details": "",
                                                                      disabled: _ctx.dbPension[_ctx.currentProviderUUIDForUser],
                                                                      label: 'DB Pension',
                                                                      modelValue: _ctx.dbPension[_ctx.currentProviderUUIDForUser],
                                                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dbPension[_ctx.currentProviderUUIDForUser]) = $event)),
                                                                      class: "mb-5"
                                                                    }, null, 8, ["disabled", "modelValue"])
                                                                  ])
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_component_v_divider, { dark: "" })
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["card", "id"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          "data-testid": "SubmitUploadBtn",
                                          color: _ctx.updatingUser ? 'disabled' : 'success',
                                          type: "submit",
                                          variant: "flat",
                                          loading: _ctx.updatingUser,
                                          disabled: _ctx.updatingUser
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.currentB2CUser.id ? 'Edit' : 'Add'), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color", "loading", "disabled"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onSubmit"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_alert, {
                modelValue: _ctx.alerts.contributionPeriod,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.alerts.contributionPeriod) = $event)),
                closable: "",
                elevation: "2",
                type: "error"
              }, {
                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                  _createTextVNode(" You've entered the wrong format for the contribution year for one of the pensions!. ", -1)
                ]))]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.showingDownloadModal,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showingDownloadModal) = $event)),
          "max-width": "600px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { style: {"padding":"20px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_table, null, {
                  default: _withCtx(() => [
                    _cache[31] || (_cache[31] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "float-left" }, "Name"),
                        _createElementVNode("th", { class: "float-right" }, "Upload Time")
                      ])
                    ], -1)),
                    (
                  _ctx.currentB2CUser &&
                  _ctx.currentB2CUser.otherData &&
                  _ctx.currentB2CUser.otherData.documents.filter((eachDoc) => eachDoc.uuid === _ctx.currentProviderUUIDForUser)
                    .length > 0
                )
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentB2CUser.otherData.documents.filter(
                    (eachDoc) => eachDoc.uuid === _ctx.currentProviderUUIDForUser
                  ), (item, id) => {
                            return (_openBlock(), _createElementBlock("tr", { key: id }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: item.src,
                                  target: "_blank"
                                }, _toDisplayString(item.name), 9, _hoisted_6)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(item.uploadTime), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_7, " No documents related to this pension found "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}